module.exports = __webpack_public_path__ + "043e0ea97af14caa5fc2c41cf10829.png";